import React from "react";
import ReactDOM from "react-dom";
// import App from "./App";
// import AppAmbassadrice from "./AppAmbassadrice";
import AppMain from "./AppMain";

//start filter if params in url : /////
/* function checkStartFilter() {
  const urlString = document.location.href;
  const url = new URL(urlString);
  const startFilter = url.searchParams.get("type");
  if (startFilter) {
    App.defaultProps = { startFilter };
  }
}
checkStartFilter(); */
/////////////////////////////////////////

//render App differente en fonction de la div présente
/* if (document.getElementById("filter-atelier")) {
  ReactDOM.render(<App />, document.getElementById("filter-atelier"));
}

if (document.getElementById("filter-ambassadrice")) {
  ReactDOM.render(
    <AppAmbassadrice />,
    document.getElementById("filter-ambassadrice")
  );
} */

/* ReactDOM.render(<AppTest />, document.getElementById("filter-atelier"));
 */

if (document.getElementById("filter-atelier")) {
  ReactDOM.render(<AppMain />, document.getElementById("filter-atelier"));
}

if (document.getElementById("filter-ambassadrice")) {
  ReactDOM.render(<AppMain />, document.getElementById("filter-ambassadrice"));
}



// WEBPACK FOOTER //
// ./src/index.js